import { SLUGLESS_REGIONS } from './routing/region'

export const isRegionAvailable = (r: { available: boolean; slug: string }) => r.available && (r.slug === 'msk' || !SLUGLESS_REGIONS.includes(r.slug))
export const isRegionHasRoute = (r: { available: boolean; slug: string }) => isRegionAvailable(r) && r.slug !== 'msk'
